// extracted by mini-css-extract-plugin
module.exports = {"root":"AdminLanguageSwitcher_root__9UvFw","current":"AdminLanguageSwitcher_current__3yP0u","error":"AdminLanguageSwitcher_error__2qA-h"};